/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosResponse } from "axios";
import {
    AllOrderReturnResponse,
    SingleReturnOrderResponse,
} from "../../@types/DRO/GetAllOrderReturnResponse";
import {
    ReturnOrderRequestBody,
    ReturnOrderResponse,
} from "../../@types/DTO/ReturnOrderBody";
import { erpAxios, getAuthToken } from "../axiosInstances";
export class DeliveryReturnApi {
  public static api = new DeliveryReturnApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async createDeliveryReturn(orderBody: ReturnOrderRequestBody): Promise<void> {
    try {
      await this.instance.post(
        `/erp/api/v1/delivery-order/return/create`,
        orderBody,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      console.log("Purchase order created successfully");
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }

  async getReturnOrderResponse(id: number): Promise<ReturnOrderResponse> {
    try {
      const response: AxiosResponse<ReturnOrderResponse> =
        await this.instance.get(`/erp/api/v1/delivery-order/${id}/returns`, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching product order details", error);
      throw error;
    }
  }

  async getReturnedOrderAllList(
    page?: number,
    pageSize?: number,
    search?: string,
    startDate?: string,
    endDate?: string,
    status?: string,
    type?: string
  ): Promise<AllOrderReturnResponse> {
    try {
      const response: AxiosResponse<AllOrderReturnResponse> =
        await this.instance.get("/erp/api/v1/order/return/all", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            page,
            pageSize,
            search,
            startDate,
            endDate,
            status,
            type,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }
  async getSingleReturnOrderDetails(
    id: number | null
  ): Promise<SingleReturnOrderResponse> {
    try {
      const response: AxiosResponse<SingleReturnOrderResponse> =
        await this.instance.get(`/erp/api/v1/order/return/details/${id}`, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }
  async cancelDeliveryOrderReturn(id: number): Promise<void> {
    try {
      await this.instance.put(
        `/erp/api/v1/delivery-order/return/cancel`,
        null,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            id,
          },
        }
      );
      console.log("Purchase order cancelled successfully");
    } catch (error) {
      console.error("Error canceling purchase order", error);
      throw error;
    }
  }
}
